export type SwatchOption = { value: string; labelKey: string };

export const TEXT_COLOR_OPTIONS: SwatchOption[] = [
  { value: "#1F1D1B", labelKey: "black" },
  { value: "#3D3A36", labelKey: "graphite" },
  { value: "#1E3A5F", labelKey: "navy" },
  { value: "#21483A", labelKey: "green" },
  { value: "#5A1F2B", labelKey: "wine" },
];

export const TITLE_COLOR_OPTIONS: SwatchOption[] = [
  { value: "#1F1D1B", labelKey: "black" },
  { value: "#B5401F", labelKey: "orange" },
  { value: "#1E3A5F", labelKey: "navy" },
  { value: "#21483A", labelKey: "green" },
  { value: "#6B2A6E", labelKey: "plum" },
];


import type { PrintZone } from "@/components/print/DocumentPreview";

export const AREAS: { zone: PrintZone; key: string }[] = [
  { zone: "page", key: "page" },
  { zone: "header", key: "header" },
  { zone: "body", key: "body" },
  { zone: "sign", key: "sign" },
  { zone: "footer", key: "footer" },
];

